export enum TargetStreamType {
  CHAT_GROUP_TARGET = 4,
  CHAT_TARGET = 3,
  PREMIUM_TARGET = 2,
  PUBLIC_TARGET = 1,
}
